"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRenderCellViews = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var formatting_1 = require("lets-trade-utils/lib/utils/formatting");
var react_redux_1 = require("react-redux");
var react_2 = require("@nextui-org/react");
function StatusCellView(_a) {
    var cellValue = _a.cellValue;
    var color = (0, react_1.useMemo)(function () {
        switch (cellValue) {
            case "PASSED_COLLECTION_TIME":
                return "danger";
            case "WITHIN_30_MIN":
                return "warning";
            default:
                return "default";
        }
    }, [cellValue]);
    return ((0, jsx_runtime_1.jsx)(react_2.Chip, __assign({ className: "text-nowrap text-xs capitalize text-default-foreground before:shrink", color: color, size: "md", variant: "flat" }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "p-1" }, { children: cellValue })) })));
}
function useRenderCellViews() {
    var client = (0, react_redux_1.useSelector)(function (state) { return state.clientState; }).client;
    var renderCellViews = (0, react_1.useCallback)(function (cellValue) {
        return [
            { key: "waybill", content: (0, jsx_runtime_1.jsx)("div", __assign({ className: "text-nowrap text-small text-default-foreground" }, { children: cellValue })) },
            { key: "createdAt", content: (0, jsx_runtime_1.jsx)("div", __assign({ className: "text-nowrap text-small text-default-foreground" }, { children: (0, formatting_1.formatDateTime)(new Date(cellValue)) })) },
            { key: "parcel_length", content: (0, jsx_runtime_1.jsx)("div", __assign({ className: "text-nowrap text-small text-default-foreground" }, { children: cellValue })) },
            { key: "waybill_mode", content: (0, jsx_runtime_1.jsx)(StatusCellView, { cellValue: cellValue }) },
        ];
    }, [client]);
    return (0, react_1.useMemo)(function () { return ({
        renderCellViews: renderCellViews,
    }); }, [renderCellViews]);
}
exports.useRenderCellViews = useRenderCellViews;
